<template>
  <div>
    <v-card class="proc-component">
      <v-card-title
        :class="btnColor"
      >
        <icon-svg :size="procIconSize" :iconName="btnIcon"/>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
// 2021.12.07 SPKA-304 svg icon
import IconSvg from  '@/vue-caas/components/IconBase.vue';
  export default {
    components: {
      IconSvg
    },
    props: {
      btnIcon: {
        default: '',
      },
      btnColor:{
        default: ''
      },
    },
    data () {
      return {
        procIconSize: 24,
      }
    },
    computed: {
    },
    watch: {
    },
  }
</script>